import { MenuItem, TextField } from '@mui/material';
import { styled as muiStyled, css } from '@mui/material/styles';
import React from 'react';

import * as GQL from '~/graphql/generated/client';
import Text, { TextProps } from '~c/components/base/text';

interface Props extends TextProps {
  className?: string;
  status?: GQL.AssessmentStatusType | null;
  assessmentID?: string;
  allowed?: boolean;
}

const assessmentStatuses = [
  {
    value: GQL.AssessmentStatusType.NotStarted,
    label: 'Not Started',
  },
  {
    value: GQL.AssessmentStatusType.InProgress,
    label: 'In Progress',
  },
  {
    value: GQL.AssessmentStatusType.InReview,
    label: 'In Review',
  },
  {
    value: GQL.AssessmentStatusType.Approved,
    label: 'Approved',
  },
  {
    value: GQL.AssessmentStatusType.Reviewed,
    label: 'Reviewed',
  },
  {
    value: GQL.AssessmentStatusType.Cancelled,
    label: 'Cancelled',
  },
  {
    value: GQL.AssessmentStatusType.WaitingForApproval,
    label: 'Waiting for Approval',
  },
  {
    value: GQL.AssessmentStatusType.Rejected,
    label: 'Rejected',
  },
  {
    value: GQL.AssessmentStatusType.Published,
    label: 'Published',
  },
];
const AssessmentStatusText: React.FC<Props> = ({
  className,
  status,
  assessmentID,
  allowed,
  ...props
}) => {
  const [updateAssessmentStatus] = GQL.useAssessmentUpdateStatusMutation();
  const updateStatusHandler = (newStatus: GQL.AssessmentStatusType) => {
    updateAssessmentStatus({
      variables: {
        input: {
          assessmentId: assessmentID ?? '',
          status: newStatus,
        },
      },
    });
  };
  const statusText = assessmentStatuses.find((e) => e.value === status);
  return (
    <Text className={className} sz="body16" {...props}>
      {!allowed ? (
        statusText?.label
      ) : (
        <TextField
          disabled={!assessmentID?.length}
          select
          defaultValue={status}
          variant="standard"
          InputProps={{
            disableUnderline: true,
          }}
        >
          {assessmentStatuses.map((option) => (
            <MenuItem
              key={option?.value}
              value={option?.value}
              onClick={() => updateStatusHandler(option.value)}
            >
              {option?.label}
            </MenuItem>
          ))}
        </TextField>
      )}
    </Text>
  );
};

export default muiStyled(AssessmentStatusText)(({ theme }) => css``);
